/* gw: best sellers — arrow-driven product track, one card per click, stops at the ends (Figma 456:631) */
(() => {
  const initCarousel = (carousel) => {
    carousel.dataset.gwInitd = 'true';
    const track = carousel.querySelector('[data-gw-best-sellers-track]');
    const prev = carousel.querySelector('[data-gw-best-sellers-prev]');
    const next = carousel.querySelector('[data-gw-best-sellers-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const item = track.firstElementChild;
      if (!item) return 0;
      return item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', debounce(update, 50), { passive: true });
    window.addEventListener('resize', debounce(update, 250));
    update();
  };

  const gwBestSellers = () => {
    document.querySelectorAll('[data-gw-best-sellers]:not([data-gw-initd])').forEach(initCarousel);
  };

  gwBestSellers();

  try {
    BoosterTheme.events.on('booster:content:update', gwBestSellers);
  } catch (error) {
    console.info('[gw-best-sellers] content update re-init unavailable', error);
  }

  document.addEventListener('shopify:section:load', gwBestSellers);
})();
